import pre from './pre';
import config from './config.vue';
import addon from './addon.vue';

export default {
    pre,
    currencyFilter: ['INR'],
    components: {
        config,
        addon,
    },
}
